/**
 * Read `location.state` from result flows (object `{ from }` or legacy string path).
 * Used by result details back link.
 */
export function getReturnRouteFromOrigin(
  state: unknown,
  fallback: string
): string {
  if (typeof state === "string") {
    return state;
  }
  if (
    state &&
    typeof state === "object" &&
    "from" in state &&
    typeof (state as { from?: string }).from === "string"
  ) {
    return (state as { from: string }).from;
  }
  return fallback;
}
